import {
  ECOW_ISOLATION_STATUS_MAPPING,
  ECOW_PERMIT_STATUS_MAPPING,
  EMOC_STATUS_MAPPING,
} from '../../../lib/constants/dbConstants';
import { optionsFromEnum } from '../../../lib/util/format';
import { PERMIT_REQUIREMENT_ENUM } from '../../../lib/constants/dbConstants';
import { JOB_ASPECT_STATUS } from '../../pages/Jobs/Jobs.constants';
import { GET_EVENTS_BY_ASSET } from '../../../graph-queries/tar/event';
import { useQuery } from '@apollo/client';
import { useSelectedAsset } from '../../../lib/util';
import { TAsset, TEvent } from '../../../lib/types';

export const getEventOptions = (asset: TAsset | undefined, data: TEvent[] | undefined) => {
  const eventMap = new Map<number, string>();
  data?.forEach((event) => {
    if (!eventMap.has(event.eventId)) {
      eventMap.set(event.eventId, event.eventDescription);
    }
  });
  const eventOptions = Array.from(eventMap.values());
  return eventOptions;
};

export const getAugmentedOptionsFromMapping = (e: Record<string, string>) =>
  optionsFromEnum({ ...e, ...JOB_ASPECT_STATUS });

export const getPermitOptions = () => [
  ...Object.values(ECOW_PERMIT_STATUS_MAPPING)
    .filter((sm) => sm.isCommon)
    .map((sm) => sm.label),
  'Other',
];

export const getIsolationOptions = () => [
  ...Object.values(JOB_ASPECT_STATUS),
  ...Object.values(ECOW_ISOLATION_STATUS_MAPPING)
    .filter((sm) => sm.isCommon)
    .map((sm) => sm.label),
  'Other',
];

export const getMocOptions = () => [
  ...Object.values(EMOC_STATUS_MAPPING)
    .filter((sm) => sm.isCommon)
    .map((sm) => sm.label),
  'Other',
];

export function getLabelForPermitStatus(status: string): string {
  return ECOW_PERMIT_STATUS_MAPPING[status as keyof typeof ECOW_PERMIT_STATUS_MAPPING]?.label || '';
}

export function getLabelForIsolationStatus(status: string): string {
  return (
    ECOW_ISOLATION_STATUS_MAPPING[status as keyof typeof ECOW_ISOLATION_STATUS_MAPPING]?.label || ''
  );
}
export function getLabelForMocStatus(status: string): string {
  return EMOC_STATUS_MAPPING[status as keyof typeof EMOC_STATUS_MAPPING]?.label || '';
}
